import AVALIACAO_STATUS from '../../../enums/AVALIACAO_STATUS';

const wStatusById = Object.entries(AVALIACAO_STATUS).reduce((pAcc, [pKey, pStatus]) => {
  pAcc[String(pStatus.id)] = pKey;
  return pAcc;
}, {});

const wEditableStatus = new Set([
  AVALIACAO_STATUS.RESPOSTA_FINALIZADA.id,
  AVALIACAO_STATUS.REVISAO_INICIADA.id
]);
const wViewableStatus = new Set([
  // AVALIACAO_STATUS.REVISAO_FINALIZADA.id,
  AVALIACAO_STATUS.CONCLUIDA.id
]);
// const wDoneStatus = new Set(['REVISAO_FINALIZADA', 'CONCLUIDA']);
const wDoneStatus = new Set(['CONCLUIDA']);

const pvNormalizeStatusText = pStatus => {
  return String(pStatus || '')
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '_')
    .toUpperCase();
};

export const getAvaliacaoStatusKey = pStatus => {
  if (pStatus === null || pStatus === undefined || pStatus === '') {
    return 'RASCUNHO';
  }

  if (typeof pStatus === 'object' && pStatus.id !== undefined && wStatusById[String(pStatus.id)]) {
    return wStatusById[String(pStatus.id)];
  }

  if (wStatusById[String(pStatus)]) {
    return wStatusById[String(pStatus)];
  }

  const xNormalizedStatus = pvNormalizeStatusText(pStatus);

  if (wStatusById[xNormalizedStatus]) {
    return wStatusById[xNormalizedStatus];
  }

  if (AVALIACAO_STATUS[xNormalizedStatus]) {
    return xNormalizedStatus;
  }

  return null;
};

export const getAvaliacaoStatus = pStatus => {
  const xStatusKey = getAvaliacaoStatusKey(pStatus);
  return xStatusKey ? AVALIACAO_STATUS[xStatusKey] : null;
};

export const getAvaliacaoStatusId = pStatus => {
  return getAvaliacaoStatus(pStatus)?.id ?? null;
};

export const getAvaliacaoStatusDescricao = pStatus => {
  const xStatus = getAvaliacaoStatus(pStatus);

  if (xStatus) {
    return xStatus.descricao;
  }

  if (pStatus === null || pStatus === undefined || pStatus === '') {
    return AVALIACAO_STATUS.RASCUNHO.descricao;
  }

  return String(pStatus);
};

export const getAvaliacaoStatusColor = pStatus => {
  return getAvaliacaoStatus(pStatus)?.color || 'warning';
};

export const isAvaliacaoWaitingStatus = pStatus => {
  return getAvaliacaoStatusKey(pStatus) === 'ENVIADA';
};

export const isAvaliacaoPendenteStatus = pStatus => {
  return getAvaliacaoStatusKey(pStatus) === 'PENDENTE';
};

export const isAvaliacaoRascunhoStatus = pStatus => {
  return getAvaliacaoStatusKey(pStatus) === 'RASCUNHO';
};

export const isAvaliacaoDoneStatus = pStatus => {
  return wDoneStatus.has(getAvaliacaoStatusKey(pStatus));
};

export const canEditAvaliacao = pStatus => {
  return wEditableStatus.has(getAvaliacaoStatusId(pStatus));
};

export const canViewAvaliacao = pStatus => {
  return wViewableStatus.has(getAvaliacaoStatusId(pStatus));
};
